export default "__VITE_ASSET__Dshzlbef__"